import Swiper from 'swiper'

export class HomeSlider {
  constructor () {
    this.registerSlider()
  }

  registerSlider () {
    const swiperOptions = {
      loop: true,
      direction: 'vertical',
      navigation: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      loopAddBlankSlides: true,
      slidesPerView: 1,
      gap: 0,
      speed: 8000,
      grabCursor: false,
      loopAdditionalSlides: 50,
    }

    const swiper = new Swiper('.slider--home', swiperOptions)
  }
}
